module.exports = __webpack_public_path__ + "static/img/fish28.b35c432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish28.png
// module id = Vsoy
// module chunks = 0